import React, { useRef } from 'react';

import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import {withScriptjs} from "react-google-maps";

const autocompleter =  withScriptjs(props => {

  let refGPA = useRef(null)

  let handleCurrentLocation = () => {
    props.handleCL();
    refGPA.current.state.value = ``
  }

  return(
      <GooglePlacesAutocomplete
        ref={refGPA}
        placeholder={props.placeholderAddress}
        className="form-control red-text-Genesis"
        loader={null}
        onSelect={(place) => props.handleACupdate(place)}
        autocompletionRequest={{
          componentRestrictions: {
            country: ['us'],
          }
        }}

        renderInput={(props) => {
          return(
            <>
              <label htmlFor="react-google-places-autocomplete-input" className="red-text-Genesis">
                Find a location - <span 
                    className="red-text-Genesis currentLocation"
                    onClick={() => handleCurrentLocation()}
                >Current Location</span>
              </label>
              <div className="google-places-autocomplete">
                <input
                  className="google-places-autocomplete__input"
                  id="-google-places-autocomplete-input"
                  // Custom properties
                  {...props}
                />
              </div> 
            </>
          )
        }}

        renderSuggestions={(active, suggestions, onSelectSuggestion) => {
          let border = ""
          if (suggestions.length > 0) {border = "borderblue"}
          return(
            <div 
              className={`google-places-autocomplete__suggestions-container ${border}`}
              id="-google-places-suggestions-container"
            > {suggestions.map((suggestion, key) => (
                  <div
                    key={key}
                    className={`google-places-autocomplete__suggestion`}
                    id={`-google-places-autocomplete-suggestion--${key}`}
                    onClick={(event) => onSelectSuggestion(suggestion, event)}
                  >{suggestion.description}</div>
                ))
            }</div>
          )
        }}
      />
    )
  }
);

export default autocompleter